<template>
	<div class="res">
		<transition name="cart">
			<minicart :class="{cartpage: cart}" v-if="minicart && $res.small()"/>
		</transition>

		<transition name="cartOverlay">
			<a class="cartOverlay" @click="close" v-if="minicart && $res.small()"/>
		</transition>
	</div>
</template>

<script>
import minicart from "@/components/cart-mini/index.vue";

export default {
	components: {minicart},
	computed: {
		minicart: (t) => t.$store.getters["cart/minicart"],
		cart: (t) => t.$route.name === "cart"
	},
	methods: {
		close() {
			this.$store.commit("cart/minicart", false);
		}
	},
	watch: {
		$route() {
			this.close();
		}
	}
};
</script>

<style lang="scss" scoped>
.res {
	.cart {
		position: fixed;
		right: 0;
		top: $header;
		margin-top: 0;
		z-index: 2;
		max-width: 100%;

		@include res(xsmall) {
			top: $headerXsmall;
		}

		&.cartpage {
			height: calc(100vh - #{$header} - 72px);
		}

		&-enter-active, &-leave-active {
			transition: cubic(transform, 0.45s);
		}

		&-enter, &-leave-to {
			transform: translateX(100%);
		}
	}

	.cartOverlay {
		z-index: 1;
		position: fixed;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		background-color: transparentize($black1, 0.5);

		&-enter-active, &-leave-active {
			transition: cubic(opacity, 0.45s);
		}

		&-enter, &-leave-to {
			opacity: 0;
		}
	}
}
</style>
